// // import React, { Component } from 'react';
// // import DashboardCharts from './DashboardCharts';
// // import EditorialWorkflow from './EditorialWorkflow';
// //
// // class DashboardChartsWrapper extends Component {
// //   render() {
// //     const { data } = this.props;
// //
// //     return (
// //       <div className="dashboardChartsWrapper">
// //         <DashboardCharts data={data} />
// //         <EditorialWorkflow />
// //       </div>
// //     );
// //   }
// // }
// //
// // export default DashboardChartsWrapper;
//
// import React, { Component } from 'react';
// import DashboardCharts from './DashboardCharts';
// import EditorialWorkflow from './EditorialWorkflow';
//
// class DashboardChartsWrapper extends Component {
//   render() {
//     const { data, onMonthFilterChange } = this.props;
//
//     return (
//       <div className="dashboardChartsWrapper">
//         <DashboardCharts
//           data={data}
//           onMonthFilterChange={onMonthFilterChange}
//         />
//         <EditorialWorkflow data={data} />
//       </div>
//     );
//   }
// }
//
// export default DashboardChartsWrapper;

import React, { Component } from 'react';
import DashboardCharts from './DashboardCharts';
import EditorialWorkflow from './EditorialWorkflow';
import RecentManuscripts from './RecentManuscripts';

class DashboardChartsWrapper extends Component {
  render() {
    const { data, onMonthFilterChange } = this.props;

    return (
      <div className="dashboardChartsWrapper">

        {/* Left column: Chart + Recent Manuscripts stacked */}
        <div className="dashboardLeftColumn">
          <DashboardCharts
            data={data}
            onMonthFilterChange={onMonthFilterChange}
          />
          <RecentManuscripts data={data} />
        </div>

        {/* Right column: Full-height workflow */}
        <EditorialWorkflow data={data} />

      </div>
    );
  }
}

export default DashboardChartsWrapper;